<template>
  <Slide fullWidth>
    <Slider
      @scrollChange="(data) => $emit('scrollChange', data)" :items="projects"
    />
  </Slide>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Slider from '@/components/Slider.vue'

export default {
  name: 'WorkSlide',
  components: {
    Slide,
    Slider
  },
  data: function () {
    return {
      projects: [
        {
          title: 'Project LAAN',
          date: '2020',
          scope: 'Dev',
          type: 'Website',
          link: 'https://projectlaan.org/',
          imageId: 'v1555604452/galacemiguel.com/projectlaan.org_.png'
        },
        {
          title: 'ReactJS Philippines Website',
          date: '2020',
          scope: 'Design & Dev',
          type: 'Website',
          link: 'https://reactjs.org.ph/',
          imageId: 'v1586269612/galacemiguel.com/reactjsph.png'
        },
        {
          title: '💧 Fluid System',
          date: '2019',
          scope: 'Dev',
          type: 'JavaScript Library',
          link: 'https://www.npmjs.com/package/fluid-system',
          imageId: 'v1572441852/galacemiguel.com/waves.jpg'
        },
        {
          title: 'Tobacco Spotter – WHO',
          date: '2018',
          scope: 'Dev',
          type: 'Website',
          link: 'https://tobaccospotter.org/',
          imageId: 'v1555601854/galacemiguel.com/TobaccoSpotter_Web10.jpg'
        },
        {
          title: 'CompSAt Poster Collection',
          date: '2015–18',
          scope: 'Design',
          type: 'Poster Designs',
          link: 'https://www.behance.net/gallery/68090155/CompSAt-Poster-Collection',
          imageId: 'v1555601858/galacemiguel.com/CompSAt-Poster-CollectionArtboard-1.png'
        },
        // {
        //   title: 'AuditHoR',
        //   date: '2018',
        //   scope: 'Design & Dev',
        //   type: 'Web App',
        //   link: 'http://galacemiguel.com/audithor',
        //   image: ''
        // },
        {
          title: 'AISIS Online Redesign Concept',
          date: '2017',
          scope: 'Design',
          type: 'Site Design Concept',
          link: 'https://www.behance.net/gallery/47185053/AISIS-Online-Redesign-Concept',
          imageId: 'v1555601848/galacemiguel.com/Artboard_1A.png'
        },
        {
          title: 'CompSAt QPI Calculator',
          date: '2016',
          scope: 'Design & Dev',
          type: 'Web App',
          link: 'http://qpi.compsat.org/',
          imageId: 'v1555604417/galacemiguel.com/qpi.compsat.org_.png'
        },
        {
          title: 'Numpad Mash',
          date: '2014',
          scope: 'Design & Dev',
          type: 'Web Game',
          link: 'https://galacemiguel.github.io/numpad-mash/',
          imageId: 'v1556346344/galacemiguel.com/galacemiguel.com_numpad-mash_play.png'
        },
        {
          title: 'HEATWorks™',
          date: '2014',
          scope: 'Design & Dev',
          type: 'Website',
          link: 'https://galacemiguel.github.io/heatworks/',
          imageId: 'v1555604443/galacemiguel.com/galacemiguel.com_heatworks_.png'
        },
        {
          title: 'BINGO Simplified™',
          date: '2014',
          scope: 'Design & Dev',
          type: 'Web Game',
          link: 'https://galacemiguel.github.io/bingo-simplified/',
          imageId: 'v1555605633/galacemiguel.com/galacemiguel.com_bingo-simplified_play.png'
        }
      ]
    }
  }
}
</script>
